// extracted by mini-css-extract-plugin
module.exports = {"container":"TemperamentsFilter_container__2BdmR"};